module.exports = __webpack_public_path__ + "img/logo-bca_qris-active.43519ff0.svg";